import { Component, OnInit } from '@angular/core'
import { ToastrModule, ToastrService } from 'ngx-toastr'
import { ReactiveFormsModule } from '@angular/forms'
import { CommonModule } from '@angular/common'
import { MatDialog, MatDialogModule } from '@angular/material/dialog'
import { ConfirmationDialogComponent } from '../../../shared/components/confirmation-dialog/confirmation-dialog.component'
import { DatatableComponent } from '../../../shared/components/master-datatable/master-datatable.component'
import { MasterAddUpdateDialogComponent } from '../../../shared/components/master-add-update-dialog/master-add-update-dialog.component'
import { TransportModeModel } from './transportMode.model'
import { TransportModeService } from './transportMode.service'
import { MasterDatabaseDisplayModel } from '../../../shared/master-database-display.model'
import { MasterCommonServices } from '../../quotation/master.common.service'

@Component({
  selector: 'app-transportmode.master',
  standalone: true,
  imports: [
    ToastrModule,
    ReactiveFormsModule,
    CommonModule,
    DatatableComponent,
  ],
  templateUrl: './transportMode.master.component.html',
  styleUrl: './transportMode.master.component.css',
})
export class TransportModeMasterComponent {
  transportmodeColumns: MasterDatabaseDisplayModel[] = [
    {
      key: 'transportMode',
      displayName: 'Transport Mode Name',
      hiddenDataTable: false,
      hiddenDialog: false,
      type: 'text',
    },
    {
      key: 'addedOn',
      displayName: 'Added Date',
      hiddenDataTable: false,
      hiddenDialog: true,
      type: 'date',
    },
    {
      key: 'id',
      displayName: 'Id',
      hiddenDataTable: true,
      hiddenDialog: true,
      type: 'text',
    },
  ]
  isLoading: boolean = false

  constructor(
    private transportmodeService: TransportModeService,
    private toastr: ToastrService,
    private dialog: MatDialog,
    public masterCommonService: MasterCommonServices,
  ) {}

  openAddUpdateTransportModeDialog(
    mode: string,
    transportmode?: TransportModeModel,
  ): void {
    const fields = this.transportmodeColumns
    const dialogRef = this.dialog.open(MasterAddUpdateDialogComponent, {
      data: { item: transportmode || {}, mode, fields },
    })

    dialogRef.afterClosed().subscribe((result) => {
      

      if (result) {
        if (mode === 'update') {
          this.updateTransportMode(result)
        } else {
          this.addTransportMode(result)
        }
      }
    })
  }

  addTransportMode(transportmode: any): void {
    this.transportmodeService.addTransportMode(transportmode).subscribe({
      next: () => {
        this.toastr.success('Transport Mode Added Successfully!', 'Success')
        this.masterCommonService.getAllPackingTypes()
      },
      error: (error: any) => {
        this.toastr.error(error.statusText, 'Error', { timeOut: 15000,
  closeButton: true,
  progressBar: true, })
      },
    })
  }

  updateTransportMode(transportmode: any): void {
    this.transportmodeService.updateTransportMode(transportmode).subscribe({
      next: () => {
        this.toastr.success('Transport Mode Updated Successfully!', 'Success')
        this.masterCommonService.getAllPackingTypes()
      },
      error: (error: any) => {
        this.toastr.error(error.statusText, 'Error', { timeOut: 15000,
  closeButton: true,
  progressBar: true, })
      },
    })
  }

  deleteTransportMode(transportmode: TransportModeModel): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: { message: 'Are you sure you want to delete this transport mode?' },
    })
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        transportmode.isDeleted = true
        this.transportmodeService.deleteTransportMode(transportmode).subscribe({
          next: () => {
            this.masterCommonService.packingTypesList = this.masterCommonService.packingTypesList.filter(
              (p) => p.id !== transportmode.id,
            )
            this.toastr.success(
              'Transport Mode Deleted Successfully!',
              'Success',
            )
          },
          error: (error: any) => {
            this.toastr.error(error.statusText, 'Error', { timeOut: 15000,
  closeButton: true,
  progressBar: true, })
          },
        })
      }
    })
  }
}
